import { DrawerContainer } from "../../../../../../components/Drawer/DrawerContainer";
import NewProviderDrawer from "./NewProviderDrawer";


export const PROVIDERS_DRAWER_ACTION_VALUES = {
    NEW_PROVIDER: 'new-provider',
    EDIT_PROVIDER: 'edit-provider',
};

const DrawerManager = ({ open, setOpen, selectedSubstance, translate, onlyVisual }: any) => {
    const handleCloseDrawer = () => {
        setOpen('');
    }
    const DrawerInputManager = () => {
        switch (open) {
            case PROVIDERS_DRAWER_ACTION_VALUES.NEW_PROVIDER:
                return (
                    <NewProviderDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selectedSubstance={selectedSubstance}
                        translate={translate}
                        isEditing={false}
                    />
                );
            case PROVIDERS_DRAWER_ACTION_VALUES.EDIT_PROVIDER:
                return (
                    <NewProviderDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selectedSubstance={selectedSubstance}
                        translate={translate}
                        isEditing={true}
                        onlyVisual={onlyVisual}
                    />
                );
            default:
                return <></>;
        }
    };

    return (
        <DrawerContainer setOpen={setOpen} open={open} customWidth={700}>
            <DrawerInputManager />
        </DrawerContainer>
    );
};

export default DrawerManager;